<template>
  <van-overlay :show="show" z-index="2000" :lock-scroll="true" @click="handleClose">
    <div class="success-popup">
      <div class="success-dialog" @click.stop>
        <div class="success-card">
          <div class="success-card__header">
            <span class="success-card__desc">请在活动结束前完成支付</span>
            <button class="success-card__btn" @click="handlePay">立即支付</button>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handlePay() {
      this.$emit('pay');
    },
  },
};
</script>

<style lang="scss" scoped>
.success-popup {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.success-dialog {
  position: relative;
  width: 634px;
  height: 551px;
  padding: 22px 0 42px;
  background: url("https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/success-bg.png")
    100% no-repeat;
  background-size: 100% 100%;

  &__title {
    display: block;
    padding-right: 42px;
    color: #fff;
    font-size: 69px;
    line-height: 83px;
    white-space: nowrap;
    text-align: right;
    text-shadow: 0 0 13px rgba(226, 0, 17, 0.68);
  }

  &__ribbon {
    position: absolute;
    top: -51px;
    left: 50%;
    width: 348px;
    height: 120px;
    margin-left: -40px;
    transform: translateX(-50%);
  }

  &__celebration {
    position: absolute;
    top: -51px;
    left: 50%;
    width: 250px;
    height: 216px;
    margin-left: 20px;
    transform: translateX(-50%);
  }

  .success-card {
    width: 581px;
    margin: 170px auto 0;

    &__header {
      padding: 69px 62px 22px 82px;
    }

    &__heading {
      display: block;
      color: #131834;
      font-weight: 700;
      font-size: 33px;
      line-height: 36px;
      white-space: nowrap;
      text-align: center;
    }

    &__desc {
      display: block;
      margin-top: 43px;
      color: #333;
      font-size: 25px;
      line-height: 36px;
      white-space: nowrap;
      text-align: center;
    }

    &__btn {
      display: block;
      width: 100%;
      margin-top: 34px;
      padding: 18px 0;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
      text-align: center;
      background-image: linear-gradient(90deg, #ff2919 0%, #ff76a0 100%);
      border: none;
      border-radius: 40px;
      outline: none;
      cursor: pointer;
    }
  }
}
</style>
